enum NumberType {
  CURRENCY = 'CURRENCY',
  NUMBER = 'NUMBER',
  PERCENTAGE = 'PERCENTAGE'
}

export default NumberType;
